import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.users');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-users',
template: templateSource || '',
    styles: [``],
})
export class PortalAdminUsersComponent implements OnInit {
    public users: any[] = [];
    public showAddModal: boolean = false;
    public newUser: any = { id: '', name: '', email: '', password: '', role: 'admin' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadUsers();
        await this.service.render();
    }

    public async loadUsers() {
        try {
            const { code, data } = await wiz.call("list");
            if (code === 200) {
                this.users = data.rows || [];
            }
        } catch (e) { }
    }

    public openAddModal() {
        this.newUser = { id: '', name: '', email: '', password: '', role: 'admin' };
        this.showAddModal = true;
        this.service.render();
    }

    public async addUser() {
        if (!this.newUser.id || !this.newUser.password) {
            return alert('아이디와 비밀번호는 필수입니다.');
        }
        const { code, data } = await wiz.call("create", this.newUser);
        if (code === 200) {
            this.showAddModal = false;
            await this.loadUsers();
        } else {
            alert(data?.message || '사용자 추가에 실패했습니다.');
        }
        await this.service.render();
    }

    public async deleteUser(id: string) {
        if (id === 'admin') {
            alert('시스템 관리자 계정은 삭제할 수 없습니다.');
            return;
        }
        if (!confirm(`'${id}' 사용자를 삭제하시겠습니까?`)) return;
        const { code } = await wiz.call("delete", { id });
        if (code === 200) {
            await this.loadUsers();
        }
        await this.service.render();
    }
}

export default PortalAdminUsersComponent;